import PropTypes from 'prop-types';
import { useSelector } from 'react-redux';

// material-ui
import { Box, List, Typography } from '@mui/material';
// project import
import  NavCollapse  from './NavCollapse';
import NavItem from './NavItem';

// ==============================|| NAVIGATION - LIST GROUP ||============================== //

const NavGroup = ({ item }) => {
    const menu = useSelector((state) => state.common);
    const { drawerOpen } = menu;

    const navCollapse = item.children?.map((menuItem) => {
        
        switch (menuItem.type) {
            case 'collapse':
                return <NavCollapse key={menuItem.id} menu={menuItem} level={1} />;
            case 'item':
                return <NavItem key={menuItem.id} item={menuItem} level={1} />;
            case 'group':
                return <NavGroup key={item.id} item={item} />;
            default:
                return (
                    <Typography key={menuItem.id} variant="h6" color="error" align="center">
                        Fix - Group Collapse or Items
                    </Typography>
                );
        }
    });

    return (
        <List
            subheader={
                item.title &&
                drawerOpen && (
                    <Box sx={{ m: '15px 0px 0px 28px' }}>
                        <Typography variant="subtitle" sx={{ color: "#72848f", fontWeight: "bold", textTransform: "uppercase" }}
                        // style = {item.title == 'Admin' ? null : {paddingLeft: '5px'}}
                        >
                            {item.title}
                        </Typography>
                    </Box>
                )
            }
            sx={{ mb: drawerOpen ? 1.5 : 0, py: 0, zIndex: 0 }}
        >
            {navCollapse}
        </List>
    );
};

NavGroup.propTypes = {
    item: PropTypes.object
};

export default NavGroup;
